import { render } from "./IconCheck.vue?vue&type=template&id=687ca5ca"
import script from "./IconCheck.vue?vue&type=script&lang=js"
export * from "./IconCheck.vue?vue&type=script&lang=js"
script.render = render

export default script